import {
  GET_CHAT_AGENTS,
  SAVE_CHAT_AGENTS,
  GET_CHAT_GROUPS,
  SAVE_CHAT_GROUPS,
  SAVE_ALL_CHAT_ASSIGNMENT_RULES,
  RESET_CHAT_ASSIGNMENT,
} from "../constants/ChatAssignment";

const initialState = {
  agents: [],
  groups: [],
  loading: false,
  allChatAssignmentRules: [],
};
const ChatAssignment = (state = initialState, action) => {
  switch (action.type) {
    case GET_CHAT_AGENTS:
      return {
        ...state,
        loading: true,
      };
    case SAVE_CHAT_AGENTS:
      return {
        ...state,
        agents: [...action.payload],
        loading: false,
      };
    case RESET_CHAT_ASSIGNMENT:
      return {
        agents: [],
        groups: [],
        loading: false,
        allChatAssignmentRules: [],
      };
    case GET_CHAT_GROUPS:
      return {
        ...state,
        loading: true,
      };
    case SAVE_CHAT_GROUPS:
      return {
        ...state,
        groups: [...action.payload],
        loading: false,
      };
    case SAVE_ALL_CHAT_ASSIGNMENT_RULES:
      return {
        ...state,
        allChatAssignmentRules: [...action.payload],
      };
    default:
      return state;
  }
};

export default ChatAssignment;
